import React, { useEffect } from 'react'

import { clearToken, KEY_STORAGE, LOCAL_STORAGE_ERROR_EMAIL_OAUTH } from '../../utils'

import { Loader } from 'components'

const Logout = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const appPlatform = urlParams.get('platform')?.toLowerCase()

  useEffect(() => {
    clearCredentials()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const clearCredentials = () => {
    clearToken()
    if (window.PLURALL_TRACKER && window.PLURALL_TRACKER.clearTrakingId) {
      window.PLURALL_TRACKER.clearTrakingId()
    }

    const hasAcceptTerm = localStorage.getItem(KEY_STORAGE)

    const errorEmail = localStorage.getItem(LOCAL_STORAGE_ERROR_EMAIL_OAUTH)

    localStorage.clear()
    sessionStorage.clear()

    if (hasAcceptTerm) {
      localStorage.setItem(KEY_STORAGE, 'true')
    }

    if (errorEmail) {
      localStorage.setItem(LOCAL_STORAGE_ERROR_EMAIL_OAUTH, errorEmail)
    }

    let logoutURL = process.env.REACT_APP_SOMOS_LOGOUT_URL
    if (appPlatform) {
      logoutURL = `${process.env.REACT_APP_SOMOS_LOGOUT_URL}/${appPlatform}`
    }
    window.location.href = logoutURL
  }

  return <Loader />
}

export default Logout
